import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  getTaskList(activityId) {
    return httpAdminClient.get(`admin/train/activities/${activityId}/tasks`);
  },
  createTask(activityId, data) {
    return httpAdminClient.post(`admin/train/activities/${activityId}/tasks`, { train_task: { ...data } });
  },
  patchTask(id, data) {
    return httpAdminClient.patch(`/admin/train/tasks/${id}`, { train_task: { ...data } });
  },
  deleteTask(id) {
    return httpAdminClient.delete(`/admin/train/tasks/${id}`);
  },
  showTask(id) {
    return httpAdminClient.get(`/admin/train/tasks/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/train/taskApi.js